import { Button } from 'reactstrap';
import {
  // useToast,
  // useTranslator,
  useAppContext,
  cloudflareImage,
  formatCalories,
} from '@front-activerse/common-components';
import { useNavigate } from 'react-router-dom';

const UserMeal = ({ meal }: { meal: any }) => {
  const navigate = useNavigate();
  // const { toastSuccess, toastError } = useToast();
  // const { t } = useTranslator();

  const {
    consts: { APP_BRAND },
    images: { addToTrackerIcon },
  } = useAppContext();

  const renderMealImage = () => {
    const coverImage = cloudflareImage(meal.imageUrl, `${APP_BRAND}`, 'cookbookMealItemVertical');
    return <img src={coverImage} className="img-fluid" alt="" width={612} height={384} />;
  };

  const handleAddMealToTracker = () => {
    navigate(`/meals/user-meals/module/tracker/add-meal/${meal.id}`);
  };

  return (
    <div className="meal">
      <div className="meal-box cursor-pointer">
        <div className="meal-image" onClick={() => navigate(`/meals/user-meals/${meal.id}`)}>
          {renderMealImage()}
        </div>

        <div className="meal-title mb-s" onClick={() => navigate(`/meals/user-meals/${meal.id}`)}>
          <p className="semi-bold mb-0">{meal.name}</p>
        </div>

        <div className="d-flex align-items-center justify-content-between">
          <span className="description text-text-variant-color">
            {formatCalories(meal.calories)}&nbsp;kcal
          </span>

          <Button
            color="primary"
            size="sm"
            className="p-xs z-index-999 tracker rounded"
            style={{ minHeight: '32px', lineHeight: '0' }}
            onClick={handleAddMealToTracker}
          >
            <img src={addToTrackerIcon} alt="" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UserMeal;
